import { DefaultSla } from '@provision/service-level-utils';

/** Fixed trial length (1V-5895); the specialist never picks a length. */
export const TRIAL_MEMBERSHIP_LENGTH_DAYS = 30;

/**
 * The only plans Basic Support may activate as a one-time trial. Essentials
 * Plus only to start (1V-6166); Priority may come back later.
 */
export const TRIAL_MEMBERSHIP_PLATFORM_SLA_IDS: string[] = [DefaultSla.EssentialsPlus];

export enum ActivateTrialMembershipFormField {
  PartnerProductId = 'partnerProductId',
  ActiveUntil = 'activeUntil',
}
